import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { SanityCallToActionButton } from "../../model/common";
import AnchorButton from "../AnchorButton/AnchorButton";
import { internalLinkUrl } from "../InternalLink/InternalLink";
import ModalTriggerButton from "../ModalTriggerButton/ModalTriggerButton";
import { usePathname } from "../../utils/usePathname";

interface CallToActionButtonProps {
  node: SanityCallToActionButton;
}

const CallToActionButton = ({
  node: {
    title,
    query,
    fragment,
    internalLink,
    externalLink,
    primary,
    targetModal,
    openInNewTab
  }
}: CallToActionButtonProps) => {
  const pathname = usePathname();
  const language = useLanguage();
  const to = internalLink
    ? internalLinkUrl(internalLink, query, fragment, language, pathname)
    : externalLink || "";
  const options = openInNewTab
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};
  if (targetModal) {
    return (
      <ModalTriggerButton
        title={title}
        primary={primary}
        targetModal={targetModal}
      />
    );
  }
  return (
    <AnchorButton primary={primary} to={to} {...options}>
      {title}
    </AnchorButton>
  );
};

export default CallToActionButton;
